import type { Locale } from "@/lib/i18n";
import { pl, type CDedicatedContactFormTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cDedicatedContactFormTranslations: Record<Locale, CDedicatedContactFormTranslations> = {
  pl,
  en,
  de,
};

export type { CDedicatedContactFormTranslations };
